<template>
  <div>
    <div class="hero">
      <img
        :src="getProp(hero, 'image', 'src')"
        :alt="getProp(hero, 'image', 'alt')"
      >

      <h1>{{ getProp(hero, 'title') }}</h1>

      <rich-text :body="getProp(hero, 'text')" />
    </div>

    <zg-cross-sell-section
      :title="getProp(crossSell, 'title')"
      :items="getProp(crossSell, 'items')"
    />
  </div>
</template>

<script>
  import RichText from '@content-sdk/components/RichText'
  import { ZgCrossSellSection } from '@zc/components/sections/ZgCrossSellSection'
  import { getProp } from '@ocp-zmarta/zmarta-cl'

  export default {
    name: 'Error',
    components: {
      RichText,
      ZgCrossSellSection
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    computed: {
      hero () {
        return getProp(this.content, 'content', 'hero')
      },
      crossSell () {
        return getProp(this.content, 'content', 'sections', '0') ?? []
      }
    },
    methods: {
      getProp
    }
  }
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  display: grid;
  justify-items: center;
  text-align: center;
  padding: rhythm("small");
  z-index: 1;

  @include mq("large") {
    margin-top: rhythm("double");
  }
}

img {
  max-height: rem(150px);

  @include mq("medium") {
    max-height: rem(300px);
  }
}
</style>
